import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Space, Typography } from 'antd'

import { getShopifyBaseUrl } from 'src/utils/helper'

const CollabsSection = (): ReactElement => {
  const { t } = useTranslation()
  const baseUrlShopify = getShopifyBaseUrl()
  return (
    <Space direction="vertical">
      <Typography.Title level={3}>
        {t('common:footer.sections.collabs')}
      </Typography.Title>
      <a
        href={`${baseUrlShopify}/blogs/collaborations/leylah-fernandez-x-bonlook`}
      >
        Leylah Fernandez
      </a>
      <a href={`${baseUrlShopify}/blogs/collaborations/taylor-hall-x-bonlook`}>
        Taylor Hall
      </a>
      <a
        href={`${baseUrlShopify}/blogs/collaborations/leylah-fernandez-x-bonlook`}
      >
        Liz Plank
      </a>
      <a href={`${baseUrlShopify}/blogs/collaborations`}>
        {t('common:footer.collabs.all_collabs')}
      </a>
    </Space>
  )
}

export default CollabsSection
